import React from 'react';
import UpdateSuccessModal from './UpdateSuccessModal';

var DeleteSuccessModal = function (props) {
  var isOpen = props.isOpen !== undefined ? props.isOpen : true;
  var message = props.message || 'Deleted Successfully';
  var subtitle = props.subtitle || 'The item has been deleted successfully.';
  var onClose = props.onClose;

  return React.createElement(UpdateSuccessModal, {
    isOpen: isOpen,
    message: message,
    subtitle: subtitle,
    onClose: onClose
  });
};

export default DeleteSuccessModal;
